const Connections = [
    {
        name: 'Gmail',
        subtitle: 'gmailconnectiondescription'
    },
    {
        name: 'Google Calendar',
        subtitle: 'googlecalendarconnectiondescription'
    },
    {
        name: 'Google Drive',
        subtitle: 'googledriveconnectiondescription'
    },
    {
        name: 'Google Docs',
        subtitle: 'googledocsconnectiondescription'
    },
    {
        name: 'Google Spreadsheets',
        subtitle: 'googlespreadsheetsconnectiondescription'
    },
    {
        name: 'AWS S3',
        subtitle: 'awss3connectiondescription'
    },
    {
        name: 'FTP',
        subtitle: 'ftpconnectiondescription'
    },
    {
        name: 'Filemaker',
        subtitle: 'filemakerconnectiondescription'
    },
]
export default Connections;